import React, { useState, useEffect } from "react";
import {
	Col,
	Container,
	FormGroup,
	Row,
	Card,
	CardImg,
	CardBody,
	CardText,
	Badge,
	Nav,
	NavItem,
	NavLink,
	TabContent,
	TabPane,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Breadcrumb,
	BreadcrumbItem,
	Table,
} from "reactstrap";
import "assets/scss/website/app.scss";
import editImage from "assets/images/edit.png";
import deleteImage from "assets/images/delete.png";
import ProfileImage from "assets/images/profile_icon.png";
import classnames from "classnames";
import { MetaTags } from "react-meta-tags";
import "react-rangeslider/lib/index.css";
import { Link } from "react-router-dom";
import TableList from "./TableList";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import { toast } from "../../../../../node_modules/react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ProfileService from "services/Website/ProfileService";

const MyLists = ({ resales, history }) => {
	const AuthData = useSelector((state) => state.Auth);
	const { t } = useTranslation();
	const profileService = new ProfileService();
	const [resalesData, setResalesData] = useState([]);
	const [activeTab, setActiveTab] = useState("Live");
	const toggleVertical = (tab) => {
		if (activeTab !== tab) setActiveTab(tab);
	};
	useEffect(() => {
		profileService.getResales().then((response) => {
			if (response && response.status === SuccessOk) {
				setResalesData([...response.data]);
			}
		});
	}, []);

	const deleteResaleHandler = (id) => {
		const updatedResales = resalesData.filter((item) => item.id !== id);
		setResalesData([...updatedResales]);
	};

	return (
		<div className="websitPages tab-details">
			<div>
				<Container
					fluid
					className="w-75 m-auto pb-4 pt-4 custom-width-responsive">
					<div className="p-2">
						<Nav pills className="navsList nav-tabs-custom nav-justified">
							<NavItem>
								<NavLink
									style={{ cursor: "pointer" }}
									className={classnames({ active: activeTab === "Live" })}
									onClick={() => {
										toggleVertical("Live");
									}}>
									{" "}
									{t("Live Listing")}
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink
									style={{ cursor: "pointer" }}
									className={classnames({ active: activeTab === "Pending" })}
									onClick={() => {
										toggleVertical("Pending");
									}}>
									{t("Pending Listing")}
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink
									style={{ cursor: "pointer" }}
									className={classnames({ active: activeTab === "Sold" })}
									onClick={() => {
										toggleVertical("Sold");
									}}>
									{t("Sold Listing")}
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink
									style={{ cursor: "pointer" }}
									className={classnames({ active: activeTab === "Rejected" })}
									onClick={() => {
										toggleVertical("Rejected");
									}}>
									{t("Rejected Listing")}
								</NavLink>
							</NavItem>
						</Nav>
					</div>
					<Row className="pt-2">
						<Col lg={12}>
							{!!resalesData?.filter((item) => item.status === activeTab)
								?.length ? (
								<TabContent activeTab={activeTab}>
									<TabPane tabId={activeTab}>
										<div dir={AuthData.lang !== "ar" ? "ltr" : "rtl"}>
											<div className="table-responsive tableMinWidth">
												<Table className="mt-4 mb-0">
													<thead>
														<tr>
															<th
																className={classnames("", {
																	"text-end": AuthData.lang === "ar",
																	"text-start": AuthData.lang !== "ar",
																})}>
																{t("Listing ID")}
															</th>
															<th
																className={classnames("", {
																	"text-end": AuthData.lang === "ar",
																	"text-start": AuthData.lang !== "ar",
																})}>
																{t("details")}
															</th>
															<th
																className={classnames("", {
																	"text-end": AuthData.lang === "ar",
																	"text-start": AuthData.lang !== "ar",
																})}>
																{t("Status")}
															</th>
															<th
																className={classnames("", {
																	"text-end": AuthData.lang === "ar",
																	"text-start": AuthData.lang !== "ar",
																})}>
																{t("Actions")}
															</th>
														</tr>
													</thead>
													<tbody>
														{resalesData
															?.filter((item) => item.status === activeTab)
															?.map((resale, index) => {
																return (
																	<TableList
																		key={index}
																		resale={resale}
																		history={history}
																		deleteResaleHandler={deleteResaleHandler}
																	/>
																);
															})}
													</tbody>
												</Table>
											</div>
										</div>
									</TabPane>
								</TabContent>
							) : (
								<p className="font-size-18 text-primary mt-5 text-center">
									No Data Found
								</p>
							)}
						</Col>
					</Row>
				</Container>
			</div>
		</div>
	);
};

export default MyLists;
